export const redempConstants = {
  INIT_REDEMPTION: "INIT_REDEMPTION",
  REDEMPTION_TOTAL_POINT: "REDEMPTION_TOTAL_POINT",
  UPDATE_TOTAL_REDEMP: "UPDATE_TOTAL_REDEMP",
  REMOVE_REDEMP_ITEM: "REMOVE_REDEMP_ITEM",
  ADD_REDEMP_ITEM_QTY: "ADD_REDEMP_ITEM_QTY",
  MINUS_REDEMP_ITEM_QTY: "MINUS_REDEMP_ITEM_QTY",
  UPDATE_REDEMP_TOTAL_POINTS: "UPDATE_REDEMP_TOTAL_POINTS"
};
